import { openBlock as e, createElementBlock as t, createStaticVNode as l } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, c = /* @__PURE__ */ l('<g clip-path="url(#a)"><path d="M5.667 5.667 8 1l2.333 4.667L15 6.444l-3.889 3.89L12.667 15 8 12.667 3.333 15l1.556-4.667L1 6.444l4.667-.777Z"></path><path fill-rule="evenodd" d="M8 .25a.75.75 0 0 1 .67.415l2.163 4.325 4.29.715a.75.75 0 0 1 .407 1.27l-3.56 3.56 1.408 4.228a.75.75 0 0 1-1.047.908L8 13.505l-4.331 2.166a.75.75 0 0 1-1.047-.908l1.409-4.227L.47 6.975a.75.75 0 0 1 .407-1.27l4.29-.715L7.329.665A.75.75 0 0 1 8 .25Zm0 2.427L6.338 6.002a.75.75 0 0 1-.548.404l-3.23.539 2.86 2.858c.2.2.27.498.18.767l-.983 2.95 3.048-1.524a.75.75 0 0 1 .67 0l3.048 1.523-.983-2.949a.75.75 0 0 1 .18-.767l2.86-2.858-3.23-.539a.75.75 0 0 1-.547-.404L8 2.677Z" clip-rule="evenodd"></path></g><defs><clipPath id="a"><path d="M0 0h16v16H0z"></path></clipPath></defs>', 2), o = [
  c
];
function d(p, r) {
  return e(), t("svg", a, [...o]);
}
const n = { render: d };
export {
  n as default,
  d as render
};
